import './style.scss'

import React, { useCallback, useEffect, useRef, useState } from 'react'

import Tags from './Tags'
import { formEvent } from '../Form/Form'

const TagsInput = ({ name, label, placeholder, initialValue, options, limit, required, filterInput, filterOutput, ref }) => {
  const _initialValue = useRef((filterInput ? filterInput(initialValue) : initialValue) || '')
  const [value, setValue] = useState(_initialValue.current)
  const element = useRef()

  const handleChange = useCallback((event) => {
    try {
      const value = event.target.value
      const tags = value.length === 0 ? [] : JSON.parse(value)
      setValue(tags.map(tag => tag.value).join(','))
    } catch (error) {
      // TODO: nothing, Tagify is inconsistent with the onChange events
    }
  }, [])

  useEffect(() => {
    if (ref) ref.current = value
    if (name) {
      const newValue = filterOutput ? value.split(',').map(filterOutput).filter(item => item) : value
      element.current.dispatchEvent(formEvent({
        action: 'UPDATE',
        name,
        value: newValue
      }))
    }
  }, [value, name, ref, filterOutput])

  useEffect(() => {
    if (name) {
      element.current.dispatchEvent(formEvent({
        action: 'REQUIRED',
        name,
        required
      }))
    }
  }, [name, required])

  useEffect(() => {
    const _element = element.current
    return () => {
      if (name) {
        _element.dispatchEvent(
          formEvent({
            action: 'REMOVE',
            name,
          })
        )
      }
    }
  }, [name])

  return (
    <div ref={element} className="tags-input">
      <div className="-text label-small-medium">{label}</div>
      <Tags
        value={_initialValue.current}
        onChange={handleChange}
        placeholder={placeholder}
        whitelist={options}
        dropdownEnabled={options ? 0 : 1}
        autoCompleteEnabled={options}
        dropdownCloseOnSelect={!options}
        enforceWhitelist={options}
        maxTags={limit}
        />
    </div>
  )
}

export default TagsInput